import React from 'react';
import { Box, ButtonBase } from '@mui/material';

export interface ChipTab {
  label: string;
  value: string;
}

interface ChipTabsProps {
  tabs: ChipTab[];
  value: string;
  onChange: (value: string) => void;
  'data-testid'?: string;
}

export const ChipTabs: React.FC<ChipTabsProps> = ({
  tabs,
  value,
  onChange,
  'data-testid': testId,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.25,
        alignItems: 'center',
        overflowX: 'auto',
        flexWrap: 'nowrap',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
      data-testid={testId}
    >
      {tabs.map(tab => {
        const isActive = tab.value === value;
        return (
          <ButtonBase
            key={tab.value}
            onClick={() => onChange(tab.value)}
            sx={{
              typography: 'body2',
              fontWeight: 500,
              px: 1.5,
              py: 0.25,
              borderRadius: 1,
              flexShrink: 0,
              color: isActive ? 'text.primary' : 'text.secondary',
              bgcolor: isActive ? 'action.selected' : 'transparent',
              '&:hover': {
                bgcolor: isActive ? 'action.selected' : 'action.hover',
              },
            }}
          >
            {tab.label}
          </ButtonBase>
        );
      })}
    </Box>
  );
};
